import { Stack, Typography } from "@mui/material";
import { WineBar } from "@mui/icons-material";
import { FormSelectCompleted } from "@/components/form/FormSelectCompleted";
import { FormMultipleAutoComplete } from "@/components/form/FormMultipleAutoComplete";
import { useMedicalCareContext } from "@/contexts/MedicalCareContext";
import InputText from "@/components/form/InputText";
import { useState, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { alcoholicIntakeOptions } from "../alcoholicIntakeOptions";
import { alcoholFrequencyOptions } from "../constants/options";
import { CollapsibleSection } from "./CollapsibleSection";

export function AlcoholFields() {
    const { control, setValue } = useMedicalCareContext();
    const [isOpen, setIsOpen] = useState(false);

    const alcoholFrequency = useWatch({
        control,
        name: "Anthropometric.alcoholFrequency",
        defaultValue: null,
    });

    const selectedAlcoholTypes = useWatch({
        control,
        name: "Anthropometric.alcoholicType",
        defaultValue: [],
    });

    const alcoholicTypeVolumes = useWatch({
        control,
        name: "Anthropometric.alcoholicTypeVolumes",
        defaultValue: {},
    });

    const showAlcoholFields =
        alcoholFrequency &&
        alcoholFrequency.value !== "Never" &&
        alcoholFrequency.value !== "";

    useEffect(() => {
        if (!selectedAlcoholTypes || !Array.isArray(selectedAlcoholTypes)) return;

        const currentVolumes = alcoholicTypeVolumes || {};
        const selectedValues = selectedAlcoholTypes
            .map((type: any) => type?.value)
            .filter(Boolean);
        const volumesToKeep: Record<string, number> = {};

        Object.keys(currentVolumes).forEach((key) => {
            if (selectedValues.includes(key)) {
                volumesToKeep[key] = currentVolumes[key];
            }
        });

        if (JSON.stringify(volumesToKeep) !== JSON.stringify(currentVolumes)) {
            setValue("Anthropometric.alcoholicTypeVolumes", volumesToKeep);
        }
    }, [selectedAlcoholTypes, setValue, alcoholicTypeVolumes]);

    useEffect(() => {
        if (!showAlcoholFields) {
            setValue("Anthropometric.alcoholic", "");
            setValue("Anthropometric.alcoholicType", []);
            setValue("Anthropometric.alcoholicTypeVolumes", {});
        }
    }, [showAlcoholFields, setValue]);

    return (
        <CollapsibleSection
            title="Consumo Alcoólico"
            icon={<WineBar sx={{ fontSize: "24px", color: "primary.main" }} />}
            isOpen={isOpen}
            onToggle={() => setIsOpen(!isOpen)}
        >
            <FormSelectCompleted
                control={control}
                name="Anthropometric.alcoholFrequency"
                label="Com que frequência você consome bebidas alcoólicas"
                selectOptions={alcoholFrequencyOptions}
            />
            {showAlcoholFields && (
                <>
                    <InputText
                        label={"Consumo diário de álcool (ml)"}
                        name={"Anthropometric.alcoholic"}
                        control={control}
                        type="number"
                    />
                    <FormMultipleAutoComplete
                        control={control}
                        name="Anthropometric.alcoholicType"
                        label="Tipos de bebidas alcoólicas"
                        selectOptions={alcoholicIntakeOptions}
                        defaultValue={[]}
                        variant="filled"
                    />

                    {selectedAlcoholTypes &&
                        Array.isArray(selectedAlcoholTypes) &&
                        selectedAlcoholTypes.length > 0 && (
                            <Stack spacing={2} sx={{ marginTop: 2 }}>
                                <Typography variant="body2" color="text.secondary" fontWeight={500}>
                                    Volume consumido por tipo de bebida (ml)
                                </Typography>
                                {selectedAlcoholTypes.map((alcoholType: any) => {
                                    if (!alcoholType?.value) return null;

                                    return (
                                        <InputText
                                            key={alcoholType.value}
                                            label={`Volume de ${alcoholType.label} (ml)`}
                                            name={`Anthropometric.alcoholicTypeVolumes.${alcoholType.value}`}
                                            control={control}
                                            type="number"
                                        />
                                    );
                                })}
                            </Stack>
                        )}
                </>
            )}
        </CollapsibleSection>
    );
}

